import { render, staticRenderFns } from "./vitamine.vue?vue&type=template&id=2712804a&scoped=true&"
import script from "./vitamine.vue?vue&type=script&lang=js&"
export * from "./vitamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712804a",
  null
  
)

export default component.exports